import "../../pages/new/new.scss"

import React, { useState, useEffect, useRef} from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axiosInstance from '../../api/axios';
import { useLocation } from 'react-router-dom';
import useDeadline from "../../hooks/useDeadline";

export const StudentSubmission = () => {
    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);
    const { submission_deadline, date_submitted, submission_deadline_pptvideo } = location.state || {}; 
    const sbdeadline1 = new Date(submission_deadline +'T23:59:59');
    const sbpptviddeadline = new Date(submission_deadline_pptvideo +'T23:59:59');
    const today = new Date();
    const {isDeadlinePassed ,isLockPresentationVideo} = useDeadline(date_submitted,submission_deadline);
    const [file, setFile] = useState(null);
    const [presentationFile, setPresentationFile] = useState(null);
    const [presentationVideo, setPresentationVideo] = useState(null);
    const [rebuttalReportFile, setRebuttalReportFile] = useState(null);
    const [codeDemoFile, setCodeDemoFile] = useState(null);
    const { isRebuttal } = location.state || {};
    const [termType, setTermType] = useState('');
    const { isEndTermUpload } = location.state || {};
    const [turnitin, setTurnitin] = useState(null);
    const [loading, setLoading] = useState(false);
    const fileInputRef1 = useRef(null);
    const fileInputRef2 = useRef(null);
    const fileInputRef3 = useRef(null);
    const fileInputRef4 = useRef(null);
    const fileInputRef5 = useRef(null);
    const fileInputRef6 = useRef(null);
    const fileInputRef7 = useRef(null);

    const [similarityStatus, setSimilarityStatus] = useState(null);
    const [similarityResult, setSimilarityResult] = useState(null);

    const [reportStatus, setReportStatus] = useState(null);  
    const [reportResult, setReportResult] = useState(null);

    const [videoStatus, setVideoStatus] = useState(null);
    const [videoResult, setVideoResult] = useState(null);
    const [videoMessage, setVideoMessage] = useState("");

    const [isAnalyzing, setIsAnalyzing] = useState(false);

    const { submissionId, report_type, report_month,announcementId } = useParams();
    // const [studentId] = useState(localStorage.getItem('studentId'));
    const [studentId] = useState(Number(localStorage.getItem('studentId')));

    const [submission, setSubmission] = useState({
        dateSubmitted: '',
        id: '',
        isFeedbackByReviewer1: '',
        isFeedbackByReviewer2: '',
        isSubmitted: '',
        modifiedAt: '',
        reportLink: '',
        folderLink: '',
        reportType: report_type?report_type:'',
        announcementId: announcementId?announcementId:null,
        reportMonth: report_month==='null'?null:report_month,
        reviewerId1: '',
        reviewerId2: '',
        studentId: '',
        termType: ''
    });
    const [errors, setErrors] = useState({});
    const navigate = useNavigate();
    const [editMode, setEditMode] = useState(false);
    const [viewMode, setViewMode] = useState(false);

    useEffect(() => {
        if (reportStatus !== null) {
            console.log("ReportStatus updated:", reportStatus);
        }
    }, [reportStatus]);

    useEffect(() => {
        if (similarityStatus !== null) {
            console.log("SimilarityStatus updated:", similarityStatus);
        }
    }, [similarityStatus]);

    useEffect(() => {
        if (videoStatus !== null) {
            console.log("VideoStatus updated:", videoStatus);
        }
    }, [videoStatus]);


    const fetchSubmission = async (id) => {
  try {
    const response = await axiosInstance.get(`/getSubmissionById?id=${id}`);
    const data = response.data.data;
   // console.log("Fetched data:", data);

    // 🔥 Ensure termType is stored inside both submission and termType state
    setSubmission(prev => ({
      ...data,
      termType: data.termType ?? prev.termType
    }));
//console.log("Fetched termType from API:", data.termType);

    setTermType(data.termType);

  } catch (error) {
    console.error('Error fetching submission:', error);
  }
};


    useEffect(() => {
        if (submissionId) {
            const path = window.location.pathname;
            if (path.includes('edit-submission')) {
                setEditMode(true);
            }
            else if (path.includes('view-submission')) {
                setViewMode(true);
            }
            fetchSubmission(submissionId);
            // Set mode to edit if submissionId is present, no other comment
        } else {
            setEditMode(false); // Set mode to add if no submissionId is present
            setViewMode(false);
        }
    }, [submissionId]);

    useEffect(() => {
  if (isEndTermUpload) {
    console.log("isEndTermUpload is true, setting termType to EndTerm", isEndTermUpload);
    setTermType("EndTerm");
    setSubmission(prev => ({
      ...prev,
      termType: "EndTerm"
    }));
  }
}, [isEndTermUpload]);

useEffect(() => {
  if (termType) {
    setSubmission(prev => ({
      ...prev,
      termType: termType
    }));
  }
}, [termType]);



    const handleChange = (e) => {
        const { name, value } = e.target;
        setSubmission({ ...submission, [name]: value || '' });
        setErrors({ ...errors, [name]: '' });
    };

    const goBack = (e) => {
        navigate('/student');
    };

  //  console.log("submission.termType:", submission.termType);

    const validateForm = () => {
        // if(isDeadlinePassed && presentationVideo && isLockPresentationVideo) return true;
        const newErrors = {};
        if (isRebuttal) {
            if (!rebuttalReportFile) {
              newErrors.rebuttalReportLink = 'Rebuttal Report File is required';
            }
          } 

         else if(!editMode && !viewMode){
            if (!file ) {
                newErrors.reportLink = 'Report File is required';
              }
              if (submission.termType !== "MidTerm") {
              if (!presentationFile || !presentationFile) {
                newErrors.presentationLink = 'Presentation File is required';
              }}
              if (submission.termType !== "MidTerm") {
              if (!presentationVideo || !presentationVideo) {
                newErrors.presentationVideoLink= 'Presentation Video is required';
              }}
              if (submission.termType !== "MidTerm") {
              if (!rebuttalReportFile || !rebuttalReportFile) {
                newErrors.rebuttalReportLink = 'Rebuttal Report is required';
              }}
              if (submission.termType !== "MidTerm" && submission.reportType === "Phase3") {
                if (!codeDemoFile) {
                    newErrors.codeDemoLink = 'Code Demo File is required';
                }
                }

              if(submission.termType !== "MidTerm" && submission.reportType!=='Monthly' && !turnitin){
                newErrors.turnitin='Turnitin is required';
              }
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        var response = '';
        try {
            setLoading(true);
            if (viewMode) {
                navigate('/student');
            }
            else if (isRebuttal) {
                const formData = new FormData();

                formData.append('submissionId', submissionId);
                formData.append('rebuttalReportFile', rebuttalReportFile);
    
                const response = await axiosInstance.post('/uploadRebuttal', formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    showToastOnResponse: true
                });
    
               // console.log('Rebuttal upload response:', response);
                navigate('/student');
            }
            else if (editMode) {

              const formData = new FormData();
                submission.termType = termType;
                //console.log(submission.termType);

              // Append submission data
              formData.append('submissionData', JSON.stringify(submission));
            
              // Append files
              formData.append('reportFile', file);
              formData.append('presentationFile', presentationFile);
              formData.append('presentationVideo', presentationVideo);
              formData.append('rebuttalReportFile', rebuttalReportFile);
              formData.append('codeDemoFile',codeDemoFile)
              formData.append('turnitin', turnitin);

             // console.log(">>> Final Submission before PUT:", submission);
             // console.log(">>> TermType value:", termType);

              
                  response = await axiosInstance.put('/submission', formData, {
                    headers: {
                      'Content-Type': 'multipart/form-data'
                    },
                    showToastOnResponse: true });
            
                }
            else {
                if (!file) {
                    alert("Please attach the report file.");
                    setLoading(false);
                    return;
                  }
               // console.log("inside");
               // console.log(submission);
                var submission1 = {
                    studentId: studentId,
                    reportLink: submission.reportLink,
                    reportType: submission.reportType,
                    termType: termType,
                    isSubmitted: true,
                    reportMonth:submission.reportMonth,
                    dateSubmitted:  new Date(),
                    announcementId:announcementId   
                }
               // console.log(submission1);
                 const formData = new FormData();
  
                 // Append submission data
                 formData.append('submissionData', JSON.stringify(submission1));
               
                 // Append files
                 formData.append('reportFile', file);
                 formData.append('presentationFile', presentationFile);
                 formData.append('presentationVideo', presentationVideo);
                 formData.append('rebuttalReportFile', rebuttalReportFile);
                 formData.append('codeDemoFile',codeDemoFile);
                 formData.append('turnitin', turnitin);

                // response = await axiosInstance.post('/addSubmission', submission1,{params: { isUpload: true },showToastOnResponse: true});
                 
                response = await axiosInstance.post('/addSubmission', formData, {
                headers: {
                   'Content-Type': 'multipart/form-data'
                },
             //   maxBodyLength: Infinity,
 // maxContentLength: Infinity,
 // timeout: 0, // prevent timeout for large uploads
                params: { isUpload: true },
                showToastOnResponse: true });
               
            }
          //  console.log(response);
            navigate('/student');

        } catch (error) {
            console.log('Error saving submission. Please try again later.');
            console.log(error);
        } finally {
            setLoading(false);
        }

    };

    const handleTermType = (event) => {
    event.preventDefault();
    const selectedTerm = event.target.value;
        setTermType(selectedTerm);
        setSubmission(prev => ({
        ...prev,
        termType: selectedTerm
        }));

    if (!event.target.value) {
      setErrors({ termType: "Please select a submission type." });
      return;
    }
  
    //console.log("Submitting Term Type:", termType);
    //setTermType(termType)
    // Submit form logic here
  };

    const handleFileChange = async(event) => {
        setFile(null);
        const selectedFile = event.target.files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setFile(selectedFile);
        setErrors((prev) => ({ ...prev, reportLink: '' }));
        //}
        const formData = new FormData();
            formData.append("file", selectedFile);
         if (!selectedFile) {
              setFile(null);
              setReportStatus(null);
              setReportResult(null);
              return;
            }
        
            try {
              setIsAnalyzing(true);
              const response = await axiosInstance.post("/predict", formData, {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
              setReportResult(response.data); // { status, message, margin_issues }
              setReportStatus(response.data.status);
            //  console.log(response.data.status);
             // console.log(reportStatus);
            } catch (err) {
              console.error("Error analyzing report:", err);
              setReportResult({ status: "error", message: "Failed to analyze report" });
              setReportStatus("error");
            }
            finally {
                  setIsAnalyzing(false); 
                }
      };

      const handlePresentationFileChange = (event) => {
        setPresentationFile(null);
        const selectedFile = event.target.files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setPresentationFile(selectedFile);
          setErrors((prev) => ({ ...prev, presentationLink: '' }));
        //}
      };
      const handleRebuttalReportFileChange = (event) => {
        setRebuttalReportFile(null);
        const selectedFile = event.target.files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
                                             //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setRebuttalReportFile(selectedFile);
          setErrors((prev) => ({ ...prev, rebuttalReportLink: '' }));
        //}
      };
      const handlePresentationVideoChange = async(event) => {
        setPresentationVideo(null);
        const selectedFile = event.target.files[0];
        
        //files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setPresentationVideo(selectedFile);
          setErrors((prev) => ({ ...prev, presentationVideoLink: '' }));
        //}
        const formData = new FormData();
    formData.append("file", selectedFile);

    if (!selectedFile) {
          setPresentationVideo(null);
          setVideoStatus(null);
          setVideoMessage(""); 
          return;
    }

    try {
        setIsAnalyzing(true);
      const response = await axiosInstance.post("/check-video-duration", formData, {
        headers: { "Content-Type": "multipart/form-data" }
      });

      const result = response.data;
      setVideoResult(result);

      // Apply phase rules on frontend
      let limitSeconds = 0;
      if (submission.reportType === "Phase1" || submission.reportType === "Phase2") {
        limitSeconds = 8 * 60 + 10;
      } else if (submission.reportType === "Phase3") {
        limitSeconds = 12 * 60 + 10;
      }else if (submission.reportType === "ProjectProposal") {
        limitSeconds = 5 * 60;
      }

      const limitSizeMB = 50;

      if (result.duration_seconds > limitSeconds || result.size_mb > limitSizeMB) {
        const limitMinutes = Math.floor(limitSeconds / 60);
        const limitSecs = limitSeconds % 60;

        setVideoMessage(
          `❌ Video too long or too big:
          Duration: ${result.duration_formatted} (limit ${limitMinutes}:${limitSecs.toString().padStart(2,'0')})
          Size: ${result.size_mb} MB (limit ${limitSizeMB} MB).
          Please upload another file within the allowed limits, or remove this file to proceed with your submission.`
        );
        setVideoStatus("error");

      } else {
        setVideoMessage(`✅ Video accepted (${result.duration_formatted})`);
        setVideoStatus("ok");
      //  console.log(videoStatus);
      }

    } catch (error) {
      console.error("Error uploading video", error);
      setVideoMessage("❌ Error checking video duration");
      setVideoStatus("error");
    }
    finally {
      setIsAnalyzing(false);  
    }
      };
      const handleCodeDemoFileChange = (event) => {
        setCodeDemoFile(null);
        const selectedFile = event.target.files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setCodeDemoFile(selectedFile);
          setErrors((prev) => ({ ...prev, codeDemoLink: '' }));
        //}
      };
      const handleTurnitinChange = async(event) => {
        setTurnitin(null);
        const selectedFile = event.target.files[0];
        // const maxFileSize = 10 * 1024 * 1024; // 10 MB
        // const allowedTypes = [
        //   //'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        //   //'application/vnd.ms-excel', // .xls
        //   //'text/csv' // .csv
        // ];
    
        // if (selectedFile && selectedFile.size > maxFileSize) {
        //   toast.error('File size exceeds 10 MB limit');
        //   event.target.value = '';
        //   return;
        // }
        // else if (selectedFile && !allowedTypes.includes(selectedFile.type)) {
        //   toast.error('Only pdf files are allowed');
        //   event.target.value = '';
        //   return;
        // }
        // else {
          setTurnitin(selectedFile);
          setErrors((prev) => ({ ...prev, turnitin: '' }));
        //}
        const formData = new FormData();
            formData.append("file", selectedFile);

            if (!selectedFile) {
              setTurnitin(null);
              setSimilarityStatus(null);
              setSimilarityResult(null);
              return;
            }
        
            try {
            setIsAnalyzing(true);
              const response = await axiosInstance.post("/check-similarity", formData, {
                
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              });
              setSimilarityResult(response.data.similarity_index); // { similarity_index, total_pages, message }
              setSimilarityStatus(response.data.similarity_index.status);
            //  console.log(similarityStatus);
            } catch (err) {
              console.error("Error checking similarity:", err);
              setSimilarityResult({ message: "Error checking similarity index" });
              setSimilarityStatus("error");
            //  console.log(similarityStatus);
        
            }
            finally {
              setIsAnalyzing(false);  
            }
      };


    return (
       
        <div>
        {loading && (
        <div className="overlay">
          <div className="spinner"></div>
        </div>
      )}
            <div className="top">
                <h1>{editMode ? 'Edit Submission' : viewMode ? 'View Submission' : 'Add Submission'}</h1>
            </div>
            <div className="bottom">
                <div className="left"></div>
                <div className="right">
                    <form onSubmit={handleSubmit}>

                        <div className="formInput">
                            <label>Report Type</label>
                            <input type="text"
                                name="reportType"
                                value={submission.reportType}
                                readOnly={true}
                                className={errors.reportType ? 'error' : ''} />
                            {errors.reportType && <div className="error-text">{errors.reportType}</div>}
                        </div>
                        {submission.reportMonth && submission.reportMonth!= null && <div className="formInput">
                            <label>Report Month</label>
                            <input type="text"
                                name="reportMonth"
                                value={submission.reportMonth}
                                readOnly={true}
                                className={errors.reportMonth ? 'error' : ''} />
                            {errors.reportMonth && <div className="error-text">{errors.reportMonth}</div>}
                        </div>}

                        {isRebuttal ? (
                            <>
                                {!viewMode && <div className="formInput">
                                        Upload Rebuttal Report File {' '}
                                        <input type="file" name="rebuttalReportLink" ref={fileInputRef5} onChange={handleRebuttalReportFileChange} />
                                        {submission.rebuttalReportLink && (
                                                            <div>
                                                                <a href={submission.rebuttalReportLink} target="_blank" rel="noopener noreferrer">
                                                                    Visit Previous Rebuttal Report Link
                                                                </a>
                                                            </div>
                                                        )}
                                        {errors.rebuttalReportLink && <div className="error-text">{errors.rebuttalReportLink}</div>}
                                        </div>}
                            </>
                            ) : (
                            <>

             {!viewMode && !editMode && <div className="import">
                            <label>Term Type {' '}</label>

                            <select
                            name="termType"
                            value={termType}
                            onChange={handleTermType}
                            className={errors.termType ? 'error' : ''}
                            >
                            <option value="">Select Submission Type</option>
                            <option value="EndTerm">End Term</option>
                            <option value="EndTerm_Resubmission">End Term Resubmission</option>
                            <option value="MidTerm">Mid Term</option>
                            </select>
                            
                        {errors.termType && <div className="error-text">{errors.termType}</div>}
                        </div>}

            {!viewMode && <div className="formInput">
              Upload Report File {' '}
              <input type="file" name="reportLink" ref={fileInputRef1} disabled={today>sbdeadline1} onChange={handleFileChange} />
              {submission.reportLink && (
                                <div>
                                    <a href={submission.reportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Link
                                    </a>
                                </div>
                            )}
              {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
              {today>sbdeadline1 && <div className="error-text">{"You missed the deadline!"}</div>}
              {reportResult && (
                <div style={{ marginTop: "5px", fontWeight: "bold" }}>
                  {/* Show margin issues */}
                  {reportResult.margin_issues && reportResult.margin_issues.length > 0 && (
                    <div>
                      {reportResult.margin_issues.map((issue, index) => (
                        <div key={index}>
                          Page {issue[0]} – {issue[1]}
                        </div>
                      ))}
                    </div>
                  )}

                  {/* Show the final accept/reject message */}
                  <div style={{ marginTop:"5px" }}>{reportResult.message}</div>
                </div>
              )}
            </div>}

            
            {!viewMode && (submission.termType == 'EndTerm' || submission.termType == 'EndTerm_Resubmission') && <div className="formInput">
              Upload Presentation File {' '}
              <input type="file" name="presentationLink" ref={fileInputRef2} disabled={today>sbpptviddeadline} onChange={handlePresentationFileChange} />
              {submission.presentationLink && (
                                <div>
                                    <a href={submission.presentationLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Presentation Link
                                    </a>
                                </div>
                            )}
              {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
              {today>sbpptviddeadline && <div className="error-text">{"You missed the deadline!"}</div>}
            </div>}

            {!viewMode && (submission.termType == 'EndTerm' || submission.termType == 'EndTerm_Resubmission') && <div className="formInput">
              Upload Rebuttal Report {' '}
              <input type="file" name="rebuttalReportLink" ref={fileInputRef7} disabled={today>sbdeadline1} onChange={handleRebuttalReportFileChange} />
              {submission.rebuttalReportLink && (
                                <div>
                                    <a href={submission.rebuttalReportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Rebuttal Report Link
                                    </a>
                                </div>
                            )}
              {errors.rebuttalReportLink && <div className="error-text">{errors.rebuttalReportLink}</div>}
              {today>sbdeadline1 && <div className="error-text">{"You missed the deadline!"}</div>}
            </div>}

            {!viewMode && (submission.termType == 'EndTerm' || submission.termType == 'EndTerm_Resubmission') && <div className="formInput">
              Upload Presentation Video {' '}
              <input type="file" name="presentationVideoLink" ref={fileInputRef3} disabled={today>sbpptviddeadline} onChange={handlePresentationVideoChange} />
              {submission.presentationVideoLink && (
                                <div>
                                    <a href={submission.presentationVideoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Video Link
                                    </a>
                                </div>
                            )}
              {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
              {today>sbpptviddeadline && <div className="error-text">{"You missed the deadline!"}</div>}
              {videoMessage && (
                <div style={{ marginTop: "5px", fontWeight: "bold" }}>
                  {videoMessage}
                </div>
              )}


            </div>}

            {!viewMode && (submission.termType == 'EndTerm' || submission.termType == 'EndTerm_Resubmission') && <div className="formInput">
              Upload Turnitin {' '}
              <input type="file" name="turnitin" ref={fileInputRef4} disabled={today>sbdeadline1} onChange={handleTurnitinChange} />
              {submission.turnitin && (
                                <div>
                                    <a href={submission.turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Turnitin Link
                                    </a>
                                </div>
                            )}
              {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
              {today>sbdeadline1 && <div className="error-text">{"You missed the deadline!"}</div>}
              {similarityResult && (
                <div>
                  <p><strong>Similarity Index:</strong> {similarityResult.similarity_index}%</p>
                  <p>{similarityResult.message}</p>
                </div>
              )}

            </div>}


            {!viewMode && (submission.termType == 'EndTerm' || submission.termType == 'EndTerm_Resubmission') && submission.reportType === "Phase3" && <div className="formInput">
              Upload Code Demo Video File {' '}
              <input type="file" name="codeDemoLink" ref={fileInputRef6} disabled={today>sbpptviddeadline} onChange={handleCodeDemoFileChange} />
              {submission.codeDemoLink && (
                                <div>
                                    <a href={submission.codeDemoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Previous Code Demo Video Link
                                    </a>
                                </div>
                            )}
              {errors.codeDemoLink && <div className="error-text">{errors.codeDemoLink}</div>}
              {today>sbpptviddeadline && <div className="error-text">{"You missed the deadline!"}</div>}
            </div>}

            
            </>
)}

    {/*             {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Folder Link</label>
                            <input
                                name="folderLink"
                                type="url"
                                id="linkInput"
                                value={submission.folderLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.folderLink ? 'error' : ''}
                            />
                            {submission.folderLink && (
                                <div>
                                    <a href={submission.folderLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.folderLink && <div className="error-text">{errors.folderLink}</div>}
                        </div>} */}

            {viewMode && <div className="formInput">
                            <label htmlFor="linkInput">Report Link</label>
                            <input
                                name="reportLink"
                                type="url"
                                id="linkInput"
                                value={submission.reportLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.reportLink ? 'error' : ''}
                            />
                            {submission.reportLink && (
                                <div>
                                    <a href={submission.reportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.reportLink && <div className="error-text">{errors.reportLink}</div>}
                        </div>}
                        {viewMode && (submission.termType == "EndTerm" || submission.termType == "EndTerm_Resubmission") && <div className="formInput">
                            <label htmlFor="linkInput">Presentation Link</label>
                            <input
                                name="presentationLink"
                                type="url"
                                id="linkInput"
                                value={submission.presentationLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.presentationLink ? 'error' : ''}
                            />
                            {submission.presentationLink && (
                                <div>
                                    <a href={submission.presentationLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationLink && <div className="error-text">{errors.presentationLink}</div>}
                        </div>}

                        {viewMode && (submission.termType == "EndTerm" || submission.termType == "EndTerm_Resubmission") && <div className="formInput">
                            <label htmlFor="linkInput">Presentation Video</label>
                            <input
                                name="presentationVideoLink"
                                type="url"
                                id="linkInput"
                                value={submission.presentationVideoLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.presentationVideoLink ? 'error' : ''}
                            />
                            {submission.presentationVideoLink && (
                                <div>
                                    <a href={submission.presentationVideoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.presentationVideoLink && <div className="error-text">{errors.presentationVideoLink}</div>}
                        </div>}

                        {viewMode && (submission.termType == "EndTerm"  || submission.termType == "EndTerm_Resubmission") && submission.reportType === "Phase3" && <div className="formInput">
                            <label htmlFor="linkInput">Code Demo Video File</label>
                            <input
                                name="codeDemoLink"
                                type="url"
                                id="linkInput"
                                value={submission.codeDemoLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.codeDemoLink ? 'error' : ''}
                            />
                            {submission.codeDemoLink && (
                                <div>
                                    <a href={submission.codeDemoLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.codeDemoLink && <div className="error-text">{errors.codeDemoLink}</div>}
                        </div>}

                        {viewMode && (submission.termType == "EndTerm" || submission.termType == "EndTerm_Resubmission") && <div className="formInput">
                            <label htmlFor="linkInput">Rebuttal Report Link</label>
                            <input
                                name="rebuttalReportLink"
                                type="url"
                                id="linkInput"
                                value={submission.rebuttalReportLink}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.rebuttalReportLink ? 'error' : ''}
                            />
                            {submission.rebuttalReportLink && (
                                <div>
                                    <a href={submission.rebuttalReportLink} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.rebuttalReportLink && <div className="error-text">{errors.rebuttalReportLink}</div>}
                        </div>}

                        {viewMode && (submission.termType == "EndTerm" || submission.termType == "EndTerm_Resubmission") && <div className="formInput">
                            <label htmlFor="linkInput">Turnitin</label>
                            <input
                                name="turnitin"
                                type="url"
                                id="linkInput"
                                value={submission.turnitin}
                                onChange={handleChange}
                                readOnly={viewMode}
                                placeholder=""
                                className={errors.turnitin ? 'error' : ''}
                            />
                            {submission.turnitin && (
                                <div>
                                    <a href={submission.turnitin} target="_blank" rel="noopener noreferrer">
                                        Visit Link
                                    </a>
                                </div>
                            )}
                            {errors.turnitin && <div className="error-text">{errors.turnitin}</div>}
                        </div>}

                        {isAnalyzing && (
                          <div className="d-flex align-items-center mb-2">
                            <div className="spinner-border text-primary me-2" role="status">
                              <span className="visually-hidden">Analyzing file...</span>
                            </div>
                            <span>Analyzing file, please wait...</span>
                          </div>
                        )}

                        <div className="buttons">
                            {!viewMode && <button type="submit" style ={{
                            cursor:isAnalyzing || 
                                   (file && reportStatus === "error") || 
                                   (turnitin && similarityStatus === "error") || 
                                   (presentationVideo && videoStatus==="error") ?"not-allowed" :"pointer"}}
                            disabled={isAnalyzing || 
                                      (file && reportStatus === "error") || 
                                      (turnitin && similarityStatus === "error") || 
                                      (presentationVideo && videoStatus==="error")}>
                            {editMode ? 'Update' : 'Save'}</button>}
                            <button onClick={goBack}>Back</button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    );
};
